
























































import { clamp, isEqual } from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'

import DefaultValueWrapper from '../../../DefaultValueWrapper.vue'
import SettingWrapper from "../../../SettingWrapper.vue";
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput, InputFieldEmits } from '../../mixins'
import { NumberInputSettings } from './types'

@Component({
  components: {
    SettingWrapper,
    DefaultValueWrapper,
    FieldWrapper,
  },
})
export default class NumberInput extends Mixins(BaseInput, InputFieldEmits) {

  get numberSettings(): NumberInputSettings {
    return this.getSettings<NumberInputSettings>()
  }

  get min(): number {
    return this.numberSettings.min ?? -Number.MAX_SAFE_INTEGER
  }

  get max(): number {
    return this.numberSettings.max ?? Number.MAX_SAFE_INTEGER
  }

  get step(): number | string {
    return this.numberSettings.step || 1
  }

  get precision(): number | undefined {
    return this.numberSettings.precision
  }

  // Specifies the format of the value presented, model keeps number
  get formatter(): (value: string | number) => string | undefined {
    return this.numberSettings.formatter
  }

  get parser(): (string: string) => number {
    return this.numberSettings.parser
  }

  get size(): string {
    return this.numberSettings.size
  }

  get numberValue(): number {
    const val = Number.parseFloat(this.value)

    return Number.isNaN(val) ? 0 : val
  }

  set numberValue(value: number) {
    const computedValue = clamp(value, this.min, this.max)

    this.value = Number.isNaN(computedValue) ? 0 : computedValue
  }

  mounted() {
    if (this.settings.settingWrapper !== undefined) {
      this.disabledSettingValueActive = isEqual(this.disabledOrActiveValue, this.value) || ((this.$slots['value-stub'] ?? false) && isEqual(this.disabledOrActiveValue, this.value))
    }
  }
}
